import styles from './styles.module.scss';
import { useState } from 'react';
import { useMenu } from 'context/MenuContext';
import getUserCountries from 'utils/getUserLocale';
import Country from './dropdown';
import { t } from 'i18next';
import { getPreferredLanguage } from 'utils/preferredLanguage';

function Locale() : JSX.Element {
  const { menu } = useMenu();
  const countries = getUserCountries(menu.roles);
  const [isVisible, changeVisibility] = useState(false);

  const preferredLanguage = getPreferredLanguage();

  const toogleSettings = () : void => {
    changeVisibility(!isVisible);
  };

  const canShowLocaleIcon = () : boolean => {
    if(!countries) return false;
    return countries.length > 1;
  };

  if(!canShowLocaleIcon())
    return <></>;

  return (
    <div id={styles['biobar-locale-container']}>
      <img
        id='biobar-locale'
        src={require(`../../assets/${preferredLanguage}.png`)}
        className={styles['biobar-locale']}
        onClick={toogleSettings}
      />

      { isVisible &&
        <div id={styles['biobar-select-locale']}>
          <p className={styles['biobar-title']}>{t('biobar.locale.title')}</p>
          {countries.map((x, i) => <Country onClick={toogleSettings} country={x} key={i} />)}
        </div>
      }
    </div>
  );
}

export default Locale;